import { render } from "./LogisticsServicesPage.vue?vue&type=template&id=506cd958"
import script from "./LogisticsServicesPage.vue?vue&type=script&lang=js"
export * from "./LogisticsServicesPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbook/Documents/freelance/naks/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__